import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import {useQuery} from '@tanstack/react-query'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const Brazebanner = ({placementId, script}) => {
    const containerRef = useRef(null)
    const {locale} = useMultiSite()
    const enabled = !!script && !!placementId

    useQuery({
        queryKey: ['braze-banner', placementId, locale?.id],
        queryFn: async () => {
            try {
                const config = JSON.parse(script)
                const braze = await import('@braze/web-sdk')
                if (!braze.isInitialized()) {
                    braze.initialize(config.brazeApiKey, {
                        baseUrl: config.brazeBaseUrl,
                        allowUserSuppliedJavascript: true,
                        enableLogging: true
                    })

                    braze.openSession()
                }

                const executeLogic = new Function(
                    'braze',
                    'banners',
                    'container',
                    'placementId',
                    config.logic
                )

                executeLogic(braze, config.banners, containerRef.current, placementId)
            } catch (error) {
                console.error('Braze banner logic error:', error)
            }

            return true
        },
        enabled,
        staleTime: 5 * 60000,
        cacheTime: 30 * 60000
    })

    return <Box ref={containerRef} id="braze-banner-container" data-placement-id={placementId} />
}

Brazebanner.propTypes = {
    placementId: PropTypes.string.isRequired,
    script: PropTypes.string
}

export default Brazebanner
